export default __webpack_public_path__ + "static/media/a017-line10.4d408c22.svg";